import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import ViewPage from '../../../../Components/ViewPage'
import { TabelaAtribuicao } from './components/tabela'
import { ContainerAtribuicao } from './styled'
import {
  useGetAtribuicaoFrota,
  useGetCategoriaPatrimonio,
} from '../../../../services/Patrimonio/atribuicaoFrota/GET'
import FormularioAtribuicao from './components/formulario'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../../services/Equipe'
import { usePostAtribuicao } from '../../../../services/Patrimonio/atribuicaoFrota/POST'
import { useDeleteAtribuicaoFrota } from '../../../../services/Patrimonio/atribuicaoFrota/DELETE'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'

const AtribuicaoFrota: React.FC = () => {
  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  //FORMULARIO
  const [update, setUpdate] = useState<number>(null)
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [dataEquipe, setDataEquipe] = useState([])
  const [dataVeiculos, setDataVeiculos] = useState([])
  const [func_selecionado, setFunc_selecionado] = useState<string>('')
  const [func_selecionado_id, setFunc_selecionado_id] = useState<number>(null)
  const [veiculo_selecionado, setVeiculo_selecionado] = useState<string>('')
  const [veiculo_selecionado_id, setVeiculo_selecionado_id] = useState<number>(null)

  //API
  const { carregando_atribuicao, data_atribuicao, refetch_data_atribuicao } = useGetAtribuicaoFrota(
    pagination,
    page,
    buscarTabela
  )
  const { carregando_salvar_atribuicao, mutate_atribuicao } = usePostAtribuicao()
  const { data_categoria_patrimonio, refetch_data_categoria_patrimonio } = useGetCategoriaPatrimonio()
  const {carregando_deletar_atribuicao, mutate_deletar_atribuicao} = useDeleteAtribuicaoFrota()

  async function listarEquipe() {
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: -1,
      status: 1,
    })

    setDataEquipe(response.data.itens)
  }

  function abrirGaveta() {
    setOpenForm(true)
  }

  function fecharGaveta() {
    setUpdate(null)
    setOpenForm(false)
    setFunc_selecionado('')
    setFunc_selecionado_id(null)
    setVeiculo_selecionado('')
    setVeiculo_selecionado_id(null)
    setUpdate(null)
  }

  function salvarAtribuicao() {
    mutate_atribuicao({
      cod_usuario: func_selecionado_id,
      veiculos: [veiculo_selecionado_id],
      refetch: () => {refetch_data_atribuicao(); fecharGaveta()},
    })
  }

  function deletar(cod_usuario, cod_veiculos) {
    setFake_loading(true)
    mutate_deletar_atribuicao({
      cod_usuario: cod_usuario,
      cod_veiculo: cod_veiculos,
      refetch_deletar: () => refetch_data_atribuicao()
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 500);
  }

  useEffect(() => {
    if (data_categoria_patrimonio?.itens?.length > 0) {
      setDataVeiculos(data_categoria_patrimonio?.itens)
    }
  }, [data_categoria_patrimonio])

  useEffect(() => {
    refetch_data_atribuicao()
    listarEquipe()
    refetch_data_categoria_patrimonio()
  }, [])

  return (
    <ContainerAtribuicao>
      <ViewPage
        title='Atribuição de frota'
        btnClick={null}
        newHide
        rotina={110}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Atribuição de frota</TitleH1>
        </div>
        <TabelaAtribuicao
          loading={carregando_atribuicao}
          list_atribuicao={data_atribuicao?.itens}
          deletar={deletar}
          abrir={abrirGaveta}
          page={page}
          setPage={setPage}
          setPagination={setPagination}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          total={data_atribuicao?.total}
          permissions={permissions}
        />
        <FormularioAtribuicao
          openForm={openForm}
          fecharGaveta={fecharGaveta}
          salvarAtribuição={salvarAtribuicao}
          carregando_atribuicao={carregando_salvar_atribuicao}
          carregando_atribuicao_editar={false}
          update={update}
          func_selecionado={func_selecionado}
          setFunc_selecionado={setFunc_selecionado}
          setFunc_selecionado_id={setFunc_selecionado_id}
          veiculo_selecionado={veiculo_selecionado}
          setVeiculo_selecionado={setVeiculo_selecionado}
          setVeiculo_selecionado_id={setVeiculo_selecionado_id}
          dataEquipe={dataEquipe}
          dataVeiculos={dataVeiculos}
        />
      </ViewPage>
    </ContainerAtribuicao>
  )
}

export default AtribuicaoFrota
